import {
  useCallback, useEffect, useMemo, useRef, useState
} from 'react'
import throttle from 'lodash.throttle'

const RESIZE_THROTTLE_INTERVAL = 100

const useElementHeight = () => {
  const elementRef = useRef(null)
  const [elementHeight, setElementHeight] = useState(0)
  const updateElementHeight = useMemo(
    () => throttle(() => {
      if (elementRef.current) {
        setElementHeight(elementRef.current.clientHeight)
      }
    }, RESIZE_THROTTLE_INTERVAL),
    []
  )
  const registerHeightWatcher = useCallback(element => {
    elementRef.current = element
    updateElementHeight()
  }, [updateElementHeight])

  useEffect(() => {
    window.addEventListener('resize', updateElementHeight)

    return () => {
      window.removeEventListener('resize', updateElementHeight)
      updateElementHeight.cancel()
    }
  }, [updateElementHeight])

  return {
    elementHeight,
    registerHeightWatcher,
    updateElementHeight
  }
}

export default useElementHeight
